import { v4 as uuidv4 } from 'uuid';

import { CommandPaletteCreateActionFn } from '../commandPalette.types';

/**
 * Creates a command palette action with a unique id.
 *
 * @param action The action parameters.
 */
export const createCommandPaletteAction: CommandPaletteCreateActionFn = (
  action,
) => {
  return {
    ...action,
    id: uuidv4(),
  };
};
